var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da função",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarFuncoes.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de perfil",
      "items": [{
        label: 'Servidor do Estado de Pernambuco',
        value: 'true'
      }, {
        label: 'Profissional externo',
        value: 'false'
      }],
      "item-text": 'label',
      "item-value": 'value',
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarFuncoes.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.servidorDoEstado,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "servidorDoEstado", $$v);
      },
      expression: "form.filters.servidorDoEstado"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    on: {
      "enter": _vm.buscarFuncoes
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarFuncoes();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterFuncao();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listFuncoes,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": "Não há registros a serem exibidos"
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.servidorDoEstado`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.servidorDoEstado ? "Servidor do Estado de Pernambuco" : "Profissional externo") + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarFuncao(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterFuncao(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarFuncao(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarFuncaoDialog', {
    attrs: {
      "visible": _vm.dialogManterFuncao.visible,
      "content": _vm.dialogManterFuncao.content,
      "edit": _vm.dialogManterFuncao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterFuncao.close();
      },
      "onSave": function ($event) {
        return _vm.buscarFuncoes();
      }
    }
  }), _c('VisualizarFuncaoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarFuncao.visible,
      "content": _vm.dialogVisualizarFuncao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarFuncao.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }